import { CustomError } from "../../../../models/custom-error";
import { ApiGetOrderStyleForShop } from "../../../front/api-order-style/api-order-style";
import { ApiBaseBack } from "../../api-base-back";

export type OrderStyleResponse = {
  orderStyleGroup: {
    orderStyleGroupID: string,
    orderStyleGroupName: string,
    orderStyleCount: number,
    orderStyle: string[],
  }[]
}

export type OrderStyleRequest = {
  productNameId: string,
  kijshopCd: string,
}

export class ApiOrderOrderStyle extends ApiBaseBack<OrderStyleResponse> {
  constructor(private params: OrderStyleRequest) {
    super(
      'GET',
      '/api/v1/orderStyle',
      'JSON',
      { productNameId: params.productNameId},
    );
  }
}